import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { UserAuth } from "../context/authContext";
import { FiMail, FiLock, FiArrowRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const Login = ({ initialView = "login" }) => {
  const [isLogin, setIsLogin] = useState(initialView === "login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const { signIn, signUp } = UserAuth();

  // Removed the global user effect that was aborting sign-ups.

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Email and password are required");
      return;
    }

    try {
      await signIn(email, password);
      toast.success("Logged in successfully");
      navigate("/dashboard");
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (!email || !password || !confirmPassword) {
      toast.error("All fields are required");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      await signUp(email, password);
      toast.success("Account created successfully");
      navigate("/dashboard");
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <>
      <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
        {/* Background Gradients */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10">
          <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary/20 rounded-full blur-[100px]" />
          <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-secondary/20 rounded-full blur-[100px]" />
        </div>

        <div className="w-full max-w-md">
          <div className="glass-card p-8 rounded-2xl shadow-2xl border border-white/10 relative z-10">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
                {isLogin ? "Welcome Back" : "Create Account"}
              </h2>
              <p className="text-text-muted mt-2">
                {isLogin
                  ? "Enter your credentials to access your account"
                  : "Sign up to start your journey with AstraHack"}
              </p>
            </div>

            <form onSubmit={isLogin ? handleLogin : handleSignUp} className="space-y-6">
              <div className="space-y-4">
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-text-muted group-focus-within:text-primary transition-colors">
                    <FiMail />
                  </div>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full pl-10 pr-4 py-3 bg-surfaceHighlight border border-border rounded-xl text-white placeholder-text-muted focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-all"
                    placeholder="Email Address"
                    required
                  />
                </div>

                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-text-muted group-focus-within:text-primary transition-colors">
                    <FiLock />
                  </div>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full pl-10 pr-4 py-3 bg-surfaceHighlight border border-border rounded-xl text-white placeholder-text-muted focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-all"
                    placeholder="Password"
                    required
                  />
                </div>

                {!isLogin && (
                  <div className="relative group">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-text-muted group-focus-within:text-primary transition-colors">
                      <FiLock />
                    </div>
                    <input
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="w-full pl-10 pr-4 py-3 bg-surfaceHighlight border border-border rounded-xl text-white placeholder-text-muted focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-all"
                      placeholder="Confirm Password"
                      required
                    />
                  </div>
                )}
              </div>

              {/* {isLogin && (
                // <div className="flex justify-end">
                //   <button
                //     type="button"
                //     onClick={() => toast.error("Password reset is not implemented yet")}
                //     className="text-sm text-text-muted hover:text-primary transition-colors"
                //   >  
                //     Forgot Password?
                //   </button>
                // </div>
              )} */}

              <button
                type="submit"
                className="w-full py-3 px-4 bg-gradient-to-r from-primary to-secondary hover:shadow-lg hover:shadow-primary/25 rounded-xl text-white font-semibold transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-2 group"
              >
                {isLogin ? "Sign In" : "Sign Up"}
                <FiArrowRight className="group-hover:translate-x-1 transition-transform" />
              </button>
            </form>

            <div className="mt-8 text-center">
              <p className="text-text-muted">
                {isLogin ? "Don't have an account?" : "Already have an account?"}{" "}
                <button
                  onClick={() => setIsLogin(!isLogin)}
                  className="text-primary hover:text-secondary font-semibold transition-colors"
                >
                  {isLogin ? "Sign Up" : "Sign In"}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
